module.exports = __webpack_public_path__ + "img/default_img.8b3544cb.svg";